import { useLocation } from "react-router-dom";

export function useQueryParam(param: string): string | null {
  const searchParams = new URLSearchParams(useLocation().search);
  return searchParams.get(param);
}
